<template>
  <div>
    <!-- begin breadcrumb -->
    <ol class="breadcrumb pull-right">
      <li class="breadcrumb-item active">
        <a href="javascript:;">广告管理</a>
      </li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">
      广告管理
      <small>配置广告内容和排期...</small>
    </h1>
    <!-- end page-header -->
    <panel title="广告位置及广告" :noButton="true">
      <Table border size="small" :columns="columns" :data="data">
        <template slot-scope="{ row }" slot="status">
          <strong v-if="row.status == 0">有效</strong>
          <strong v-else style="color:red">无效</strong>
        </template>

        <template slot-scope="{ row, index }" slot="action">
          <button
            type="button"
            class="btn btn-theme btn-sm"
            style="margin-right: 5px"
            @click="fn_edit_ad(row, index)"
          >广告管理</button>

          <button
            type="button"
            class="btn btn-theme btn-sm"
            style="margin-right: 5px"
            @click="fn_edit_adposition(row, index)"
          >广告位管理</button>

          <!-- <Poptip
            transfer
            confirm
            title="是否要删除此类型以及对应的属性?"
            @on-ok="fn_remove(row, index)"
            ok-text="确认"
            cancel-text="取消"
          >
            <button type="button" class="btn btn-danger btn-sm">作废</button>
          </Poptip>-->
        </template>
      </Table>
      <Page
        style="margin-top:10px"
        :total="totalRows"
        :current="currentPage"
        :page-size="pageNum"
        show-total
        show-elevator
        @on-change="fn_switchPage"
      />
    </panel>

    <Drawer title="广告位信息" v-model="v_edit_adposition" :width="50" :mask-closable="true">
      <Form :model="formData" ref="formData" :rules="rules" :labelWidth="120">
        <FormItem label="广告位高度" label-position="top" prop="heightval">
          <InputNumber v-model="formData.heightval" placeholder="广告位高度" />
        </FormItem>

        <FormItem label="状态" label-position="top">
          <Select v-model="formData.status">
            <Option :value="0">有效</Option>
            <Option :value="-1">无效</Option>
          </Select>
        </FormItem>

        <FormItem label="备注">
          <Input type="textarea" v-model="formData.remarks" />
        </FormItem>
      </Form>
      <div class="demo-drawer-footer">
        <button
          type="button"
          class="btn btn-default"
          style="margin-right: 8px"
          @click="v_edit_adposition = false"
        >关闭</button>
        <button type="button" class="btn btn-theme" @click="fn_store_adposition">保存</button>
      </div>
    </Drawer>
  </div>
</template>
<script>
import { getAdPositionList, storeAdPositionData } from "@/api/ad";
export default {
  data() {
    return {
      columns: [
        {
          title: "广告位代码",
          key: "code",
          width: 150
        },
        {
          title: "广告位名称",
          key: "name",
          width: 200
        },
        {
          title: "广告位高度",
          key: "heightval",
          width: 100
        },
        {
          title: "备注",
          key: "remarks"
        },
        {
          title: "广告数",
          key: "adcount",
          width: 100
        },
        {
          title: "状态",
          slot: "status",
          width: 120
        },
        {
          title: "操作",
          slot: "action",
          width: 280,
          align: "left"
        }
      ],
      data: [],

      totalRows: 0,
      pageNum: 10,
      currentPage: 1,
      v_edit_adposition: false,
      formData: {
        id: 0,
        heightval: 0,
        status: 0,
        remarks: ""
      },
      rules: {
        heightval: [
          {
            type: "number",
            min: 100,
            required: true,
            message: "高度必填",
            trigger: "blur"
          }
        ]
      }
    };
  },
  mounted() {
    let filterCond = {
      page: 1,
      pageNum: this.pageNum
    };
    this.fn_load_data(filterCond);
  },
  methods: {
    fn_load_data(filterCond) {
      getAdPositionList(filterCond).then(res => {
        this.data = res.data.data;
        this.totalRows = res.data.total;
      });
    },
    fn_switchPage(page) {
      this.currentPage = page;
      let filterCond = {
        page: page,
        pageNum: this.pageNum
      };
      this.fn_load_data(filterCond);
    },

    fn_edit_attribute(row, index) {
      const route = {
        name: "goods_typeattribute",
        params: { data: row }
      };
      this.$router.push(route);
    },
    fn_edit_ad(row, index) {
      const route = {
        name: "marketing_editad",
        params: { data: row }
      };
      this.$router.push(route);
    },
    fn_remove(row, index) {
      removeTypeData(row.id)
        .then(res => {
          if (res.data.code == 200) {
            this.data.splice(index, 1);
            this.$Notice.success(res.data);
          } else {
            this.$Notice.error(res.data);
          }
        })
        .catch(error => {
          this.$Message.error(error);
        });
    },
    fn_edit_adposition(row, index) {
      this.v_edit_adposition = true;
      this.formData = row;
    },
    fn_store_adposition(row, index) {
      this.$refs.formData.validate(valid => {
        if (valid) {
          storeAdPositionData(this.formData)
            .then(res => {
              if (res.data.code == 200) {
                this.v_edit_adposition = false;
                this.$Notice.success(res.data);
              } else {
                this.$Notice.error(res.data);
              }
            })
            .catch(error => {
              this.$Message.error(error);
            });
        }
      });
    }
  }
};
</script>
